import {
  WhyWorkPlacePayWrapper,
  LeftContent,
  RightContent,
  FeatureItem,
  FeatureIcon,
  FeatureText,
  SubheadingContainer,
} from "./styled";
import { H2, H3, P } from "../../../components/typography/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalculator,
  faDollarSign,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";

export const WhyWorkPlacePay = () => {
  const features = [
    {
      id: 1,
      icon: faCalculator,
      title: "Automate salary calculations",
      description:
        "Complex gross-to-net calculations handled instantly for every employee type.",
    },
    {
      id: 2,
      icon: faDollarSign,
      title: "Tax deductions",
      description:
        "Stay compliant with automated tax withholding based on local and federal regulations.",
    },
    {
      id: 3,
      icon: faCheckCircle,
      title: "Regulatory compliance",
      description:
        "We monitor changing labor laws so you don't have to, ensuring your records are always audit-ready.",
    },
  ];

  return (
    <WhyWorkPlacePayWrapper id="why">
      <LeftContent>
        <H2>Why workPlacePAY?</H2>
        <P>
          Empower your business with our hassle-free payroll management
          solution, designed to save you time and ensure accuracy every month.
        </P>
      </LeftContent>

      <RightContent>
        <SubheadingContainer>
          <H3>Streamline Your Payroll, Simplify Your Business</H3>
          <P>
            Our platform is a comprehensive payroll management solution. We
            don't just process payments, we provide a robust ecosystem that
            handles every complexity of modern employment finance.
          </P>
        </SubheadingContainer>
        <div className="features-container">
          {features.map((feature) => (
            <FeatureItem key={feature.id}>
              <FeatureIcon>
                <FontAwesomeIcon icon={feature.icon} />
              </FeatureIcon>
              <FeatureText>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </FeatureText>
            </FeatureItem>
          ))}
        </div>
      </RightContent>
    </WhyWorkPlacePayWrapper>
  );
};
